import React from 'react';
import { Sidebar } from 'primereact/sidebar';
import UserForm from './user-form.component';
import { User } from '../types';

interface UserSidebarProps {
  visible: boolean;
  onHide: () => void;
  selectedUser?: User;
  onSubmit: (userData: { id?: number; email: string; password?: string; role: string }) => Promise<boolean>;
  isEditMode: boolean;
}

const UserSidebar: React.FC<UserSidebarProps> = ({ 
  visible, 
  onHide, 
  selectedUser, 
  onSubmit, 
  isEditMode 
}) => {
  return (
    <Sidebar
      visible={visible}
      position="right"
      onHide={onHide}
      className="p-sidebar-md"
    >
      <UserForm 
        user={selectedUser}
        onSubmit={onSubmit}
        onCancel={onHide}
        isEditMode={isEditMode}
      />
    </Sidebar>
  );
};

export default UserSidebar; 